import Vue from 'vue'
import App from './App.vue'
import router from './router/router';

import DefaultLayout from './layouts/Default.vue';

Vue.config.productionTip = false

Vue.component('app-default-layout', DefaultLayout);

new Vue({
	router: router,
	render: h => h(App),
}).$mount('#app')
